<template>
  <div>
    <div class="my-4">
      <h3>{{ $t('vacancies.found', { count: vacancyData.total }, vacancyData.total + ' vacatures gevonden') }}</h3>
    </div>
    <v-row>
      <v-col
        v-for="vacancy in vacancyData.vacancies"
        :key="vacancy.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <VacancyCard :vacancy="vacancy" />
      </v-col>
    </v-row>
    
    <v-pagination
      v-if="totalPages > 1"
      v-model="currentPage"
      :length="totalPages"
      class="mt-4"
      @update:model-value="changePage"
    />
  </div>
</template>

<script setup>
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const props = defineProps({
  vacancyData: {
    type: Object,
    default: () => ({ total: 0, vacancies: [] })
  }
})

const itemsPerPage = 15
const currentPage = computed(() => {
  const page = parseInt(route.query.page) || 1
  return Math.max(1, Math.min(page, totalPages.value))
})

const totalPages = computed(() => {
  return Math.ceil(props.vacancyData.total / itemsPerPage)
})

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    const query = { ...route.query }
    query.page = page;
  
    router.replace({ query })
  }
}
</script>